import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ScrollableSteps from '../../../components/ScrollableSteps/ScrollableSteps'
import { twMerge } from 'tailwind-merge'
import SectionWithTag from '../../../components/SectionWithTag'
import { useIsMobile } from '../../../utils/helpers'
import { Color } from '../../../utils/constants'

const id = 'page.technology.segments'

const steps = [
    {
        id: `${id}.data`,
        slug: 'data',
    },
    {
        id: `${id}.artificial-intelligence`,
        slug: 'ai',
    },
    {
        id: `${id}.physics`,
        slug: 'physics',
    },
    {
        id: `${id}.laboratory`,
        slug: 'lab',
    },
]

const Segments = () => {
    const [isVisible, setIsVisible] = useState(false)
    const [padding, setPadding] = useState<number | undefined>(undefined)
    const isMobile = useIsMobile()

    const calculatePadding = useCallback(
        (ref: HTMLDivElement) => {
            if (!isMobile) {
                setPadding(ref.getBoundingClientRect().right)
            } else {
                setPadding(undefined)
            }
        },
        [isMobile],
    )
    return (
        <div
            className={twMerge(
                'md:border-t border-black/10 relative transition duration-700 pt-16 md:pt-30',
                isVisible ? 'bg-green-light' : 'bg-white',
            )}
        >
            <SectionWithTag
                tag={{ id: `${id}.tag` }}
                resizeCallback={calculatePadding}
                className=' 3xl:max-w-screen-2xl mx-auto md:pb-20'
            >
                <div>
                    <div className='max-w-[830px] mx-auto text-center pt-16 md:p-0'>
                        <FormattedMessage id={id} tagName='h2' />
                    </div>
                </div>
            </SectionWithTag>
            <ScrollableSteps
                steps={steps}
                padding={padding}
                setIsVisible={setIsVisible}
                color={Color.GREEN_LIGHT}
            />
        </div>
    )
}

export default Segments
